module.exports = __webpack_public_path__ + "img/success.407f125b.png";